import React from 'react';
import Icon from '../../../components/AppIcon';

const SessionBanner = ({ timeRemaining, onResume, savedSteps, totalSteps, lastAutoSave, isAutoSaving }) => {
  if (!timeRemaining) return null;

  const { days, hours, minutes, isExpiringSoon, expired } = timeRemaining;
  
  // Format auto-save time
  const formatAutoSaveTime = (date) => {
    if (!date) return null;
    return date.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit',
      hour12: true 
    });
  };

  if (expired) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
        <div className="flex items-start gap-3">
          <Icon name="AlertTriangle" size={20} className="text-red-600 mt-0.5" />
          <div>
            <h3 className="text-sm font-semibold text-red-800">Session Expired</h3>
            <p className="text-sm text-red-700 mt-1">
              Your registration session has expired. Please request a new invite to continue.
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Calculate progress
  const completedSteps = savedSteps?.size || 0;
  const progress = Math.round((completedSteps / totalSteps) * 100);

  return (
    <div className={`rounded-lg p-4 mb-6 ${
      isExpiringSoon 
        ? 'bg-amber-50 border border-amber-200' 
        : 'bg-blue-50 border border-blue-200'
    }`}>
      <div className="flex items-start gap-3">
        <Icon 
          name={isExpiringSoon ? "Clock" : "Save"} 
          size={20} 
          className={isExpiringSoon ? "text-amber-600 mt-0.5" : "text-blue-600 mt-0.5"} 
        />
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <h3 className={`text-sm font-semibold ${
              isExpiringSoon ? 'text-amber-800' : 'text-blue-800'
            }`}>
              {isExpiringSoon ? 'Session Expiring Soon' : 'Your Progress is Saved'}
            </h3>
            {completedSteps > 0 && (
              <span className="text-xs font-medium text-slate-600">
                {completedSteps}/{totalSteps} steps completed
              </span>
            )}
          </div>
          
          {/* Progress bar */}
          {completedSteps > 0 && (
            <div className="mt-2 h-1.5 bg-slate-200 rounded-full overflow-hidden">
              <div 
                className={`h-full rounded-full transition-all duration-500 ${
                  isExpiringSoon ? 'bg-amber-500' : 'bg-blue-500'
                }`}
                style={{ width: `${progress}%` }}
              />
            </div>
          )}
          
          <p className={`text-sm mt-2 ${
            isExpiringSoon ? 'text-amber-700' : 'text-blue-700'
          }`}>
            {isExpiringSoon 
              ? `Complete your registration soon! Time remaining: `
              : `Your progress is automatically saved. You have `
            }
            <span className="font-medium">
              {days > 0 && `${days} day${days > 1 ? 's' : ''}, `}
              {hours > 0 && `${hours} hour${hours > 1 ? 's' : ''}`}
              {days === 0 && hours === 0 && `${minutes} minute${minutes > 1 ? 's' : ''}`}
            </span>
            {isExpiringSoon ? '' : ' to complete.'}
          </p>
          
          {/* Auto-save indicator */}
          {(lastAutoSave || isAutoSaving) && (
            <div className="mt-2 flex items-center gap-2">
              {isAutoSaving ? (
                <>
                  <div className="animate-spin rounded-full h-3 w-3 border-2 border-blue-600 border-t-transparent"></div>
                  <span className="text-xs text-blue-600">Saving draft...</span>
                </>
              ) : (
                <span className="text-xs text-blue-600">
                  Draft auto-saved at {formatAutoSaveTime(lastAutoSave)}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SessionBanner;











